<div class="bg-container">
  <div class="container h-100 d-flex justify-content-center align-items-center">
    <div class="card login-card shadow-lg">
      <div class="card-body p-5">
        <!-- Title -->
        <h4 class="text-center mb-4 login-title">Autotaxatie Partners Monitoring</h4>

        @if (error) {
        <div class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-circle me-2"></i>{{ error }}
        </div>
        }

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="mb-4">
            <label for="username" class="form-label fw-semibold">
              <i class="fas fa-user me-2 text-primary"></i>Gebruikersnaam
            </label>
            <input type="text" formControlName="username" class="form-control form-control-lg" id="username"
              [class.is-invalid]="submitted && f['username'].errors" />
            @if (submitted && f['username'].errors) {
            <div class="invalid-feedback">Gebruikersnaam is verplicht</div>
            }
          </div>

          <div class="mb-4">
            <label for="password" class="form-label fw-semibold">
              <i class="fas fa-lock me-2 text-primary"></i>Wachtwoord
            </label>
            <input type="password" formControlName="password" class="form-control form-control-lg" id="password"
              [class.is-invalid]="submitted && f['password'].errors" />
            @if (submitted && f['password'].errors) {
            <div class="invalid-feedback">Wachtwoord is verplicht</div>
            }
          </div>

          @if (loginTypes.length > 1) {
          <div class="mb-4">
            <label for="loginType" class="form-label fw-semibold">
              <i class="fas fa-user-tag me-2 text-primary"></i>Login type
            </label>
            <select formControlName="login_type" class="form-select form-select-lg" id="loginType">
              <option value="company">Bedrijf</option>
              <option value="person">Persoon</option>
            </select>
          </div>
          }

          <div class="mb-4">
            <label for="screenType" class="form-label fw-semibold">
              <i class="fas fa-desktop me-2 text-primary"></i>Type scherm
            </label>
            <select (change)="setScreenType()" formControlName="screen_type" class="form-select form-select-lg"
              id="screenType">
              <option value="spoed">Spoedtaxatie</option>
              <option value="statistieken">Statistieken</option>
              <option value="it">IT</option>
            </select>
          </div>

          <button [disabled]="loading" class="btn btn-primary btn-lg w-100 py-3 fw-semibold">
            @if (loading) {
            <span class="spinner-border spinner-border-sm me-2"></span>
            }
            <i class="fas fa-sign-in-alt me-2"></i>Inloggen
          </button>
        </form>
      </div>
    </div>
  </div>
</div>